// src/i18n/es/hmiSimulator.js
const hmiSimulator = {
    name: 'Simulador HMI',
    messages: {
        device_provisioned_successfully: 'Dispositivo provisionado con éxito',
    },
};

export default hmiSimulator;
